/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';
import {QuestionnaireFinishResponseModel} from "../../models/questionnaire-finish-response-model";


export interface QuestionnaireInstanceFinishPostParams {
  questionnaireInstanceGuid: string;
  finishedEarly?: boolean;
}

export function questionnaireInstanceFinishPost(http: HttpClient, rootUrl: string, params: QuestionnaireInstanceFinishPostParams, context?: HttpContext): Observable<StrictHttpResponse<QuestionnaireFinishResponseModel>> {
  const rb = new RequestBuilder(rootUrl, questionnaireInstanceFinishPost.PATH, 'post');
  if (params) {
    rb.path('questionnaireInstanceGuid', params.questionnaireInstanceGuid, {"style":"simple"});
    rb.query('finishedEarly', params.finishedEarly, {"style":"form"});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: '*/*', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return (r as HttpResponse<any>) as StrictHttpResponse<QuestionnaireFinishResponseModel>;
    })
  );
}

questionnaireInstanceFinishPost.PATH = '/api/v1/questionnaire-instances/{questionnaireInstanceGuid}/finish';
